

<template slot="Content">
  <router-view></router-view>
</template>

<script>
    import router from '@/router/index.js'
    export default {
        name: 'MasterLibrary',
        router,
        watch:{
            "$route.params.stationUid":function(){
              // CAN BE REMOVE IF WE WANT TO KEEP THE SEARCH PARAMS WHEN CHANGING STATION
              this.$store.dispatch('advancedSearch/reset');
            }
        }
    };
</script>